// This file is auto-generated by @hey-api/openapi-ts

import { client } from './client.gen.js';
import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client/index.js';
import type { DeleteAirportsFavoritesByAirportIdData, DeleteAirportsFavoritesByAirportIdResponses, DeleteFlightsByIdData, DeleteFlightsByIdResponses, DeleteRouteTemplatesByIdData, DeleteRouteTemplatesByIdResponses, DeleteUsersMeAvatarData, DeleteUsersMeAvatarResponses, DeleteUsersMeDeviceRegistrationsData, DeleteUsersMeDeviceRegistrationsResponses, GetAircraftsByIdDocumentsData, GetAircraftsByIdDocumentsResponses, GetAircraftsByIdOwnersData, GetAircraftsByIdOwnersResponses, GetAircraftsByRegistrationByTailNumberData, GetAircraftsByRegistrationByTailNumberResponses, GetAircraftsData, GetAircraftsResponses, GetAirportsByIdentData, GetAirportsByIdentFrequenciesData, GetAirportsByIdentFrequenciesResponses, GetAirportsByIdentResponses, GetAirportsByIdentRunwaysData, GetAirportsByIdentRunwaysResponses, GetAirportsByIdentWeatherMetarData, GetAirportsByIdentWeatherMetarErrors, GetAirportsByIdentWeatherMetarResponses, GetAirportsByIdentWeatherTafData, GetAirportsByIdentWeatherTafErrors, GetAirportsByIdentWeatherTafResponses, GetAirportsData, GetAirportsDatasetHistoryData, GetAirportsDatasetHistoryResponses, GetAirportsDatasetVersionData, GetAirportsDatasetVersionResponses, GetAirportsDistanceData, GetAirportsDistanceResponses, GetAirportsFavoritesData, GetAirportsFavoritesResponses, GetAirportsFavoritesSyncData, GetAirportsFavoritesSyncResponses, GetAirportsNearbyData, GetAirportsNearbyResponses, GetAirportsResponses, GetAirportsSyncData, GetAirportsSyncErrors, GetDocumentVaultByIdData, GetDocumentVaultByIdDownloadData, GetDocumentVaultByIdDownloadResponses, GetDocumentVaultByIdResponses, GetDocumentVaultData, GetDocumentVaultRemindersDueData, GetDocumentVaultRemindersDueResponses, GetDocumentVaultResponses, GetFlightsByFlightIdLocationsData, GetFlightsByFlightIdLocationsLatestData, GetFlightsByFlightIdLocationsLatestResponses, GetFlightsByFlightIdLocationsResponses, GetFlightsByFlightIdTimeClassificationData, GetFlightsByFlightIdTimeClassificationResponses, GetFlightsByIdData, GetFlightsByIdResponses, GetFlightsData, GetFlightsMetricsData, GetFlightsMetricsResponses, GetFlightsResponses, GetJobsStatusData, GetJobsStatusResponses, GetNavaidsByIdentData, GetNavaidsByIdentResponses, GetNavaidsData, GetNavaidsResponses, GetNotificationsAdminAcknowledgementsData, GetNotificationsAdminAcknowledgementsResponses, GetNotificationsAdminBroadcastsData, GetNotificationsAdminBroadcastsResponses, GetNotificationsAdminDeliveriesData, GetNotificationsAdminDeliveriesResponses, GetNotificationsAdminEscalationsData, GetNotificationsAdminEscalationsResponses, GetNotificationsAdminEventsData, GetNotificationsAdminEventsResponses, GetNotificationsAdminNotificationsData, GetNotificationsAdminNotificationsResponses, GetNotificationsAdminTemplatesByCodeData, GetNotificationsAdminTemplatesByCodeResponses, GetNotificationsAdminTemplatesData, GetNotificationsAdminTemplatesResponses, GetNotificationsByIdData, GetNotificationsByIdResponses, GetNotificationsData, GetNotificationsResponses, GetNotificationsSyncData, GetNotificationsSyncResponses, GetPilotsByPilotIdSchedulesFullData, GetPilotsByPilotIdSchedulesFullResponses, GetPilotsByPilotIdSchedulesMetricsData, GetPilotsByPilotIdSchedulesMetricsResponses, GetPilotsByPilotIdSchedulesMonthlyData, GetPilotsByPilotIdSchedulesMonthlyResponses, GetPilotsByPilotIdSchedulesPendingData, GetPilotsByPilotIdSchedulesPendingResponses, GetPilotsByPilotIdSchedulesUpcomingData, GetPilotsByPilotIdSchedulesUpcomingResponses, GetPilotsByPilotIdSchedulesWeeklyData, GetPilotsByPilotIdSchedulesWeeklyResponses, GetQualificationsReportData, GetQualificationsReportResponses, GetReportsFlightOperationsData, GetReportsFlightOperationsResponses, GetRouteTemplatesByIdData, GetRouteTemplatesByIdNavigationData, GetRouteTemplatesByIdNavigationResponses, GetRouteTemplatesByIdResponses, GetRouteTemplatesData, GetRouteTemplatesResponses, GetRouteTemplatesSyncData, GetRouteTemplatesSyncResponses, GetSchedulesFullData, GetSchedulesFullResponses, GetSchedulesMetricsData, GetSchedulesMetricsResponses, GetSchedulesMonthlyData, GetSchedulesMonthlyResponses, GetSchedulesPendingData, GetSchedulesPendingResponses, GetSchedulesUpcomingData, GetSchedulesUpcomingResponses, GetSchedulesWeeklyData, GetSchedulesWeeklyResponses, GetUsersData, GetUsersMeData, GetUsersMeResponses, GetUsersRecoveryRawData, GetUsersRecoveryRawResponses, GetUsersResponses, GetWaypointsByIdentifierData, GetWaypointsByIdentifierResponses, GetWaypointsData, GetWaypointsNearbyData, GetWaypointsNearbyResponses, GetWaypointsResponses, GetWaypointsSyncData, GetWaypointsSyncResponses, PatchAircraftsByIdData, PatchAircraftsByIdResponses, PatchAirportsByIdData, PatchAirportsByIdErrors, PatchAirportsByIdResponses, PatchFlightsByIdCancelData, PatchFlightsByIdCancelResponses, PatchFlightsByIdData, PatchFlightsByIdResponses, PatchNotificationsByIdReadData, PatchNotificationsByIdReadResponses, PatchRouteTemplatesByIdData, PatchRouteTemplatesByIdResponses, PatchUsersByIdActiveData, PatchUsersByIdActiveResponses, PatchUsersByIdData, PatchUsersByIdResponses, PatchUsersByIdRolesData, PatchUsersByIdRolesResponses, PostAdminFlightsByFlightIdLocationsByPointIdRemovalRequestsData, PostAdminFlightsByFlightIdLocationsByPointIdRemovalRequestsResponses, PostAdminQueryData, PostAdminQueryResponses, PostAircraftsByIdDocumentsData, PostAircraftsByIdDocumentsResponses, PostAircraftsByIdWeightBalanceValidateData, PostAircraftsByIdWeightBalanceValidateResponses, PostAircraftsData, PostAircraftsResponses, PostAirportsData, PostAirportsErrors, PostAirportsFavoritesData, PostAirportsFavoritesResponses, PostAirportsFavoritesSyncData, PostAirportsFavoritesSyncResponses, PostAirportsResponses, PostAirportsSyncData, PostAirportsSyncErrors, PostAuthBootstrapFirstAdminData, PostAuthBootstrapFirstAdminResponses, PostAuthChangePasswordData, PostAuthChangePasswordResponses, PostAuthEmailVerificationResendData, PostAuthEmailVerificationResendResponses, PostAuthEmailVerificationVerifyData, PostAuthEmailVerificationVerifyResponses, PostAuthForgotPasswordData, PostAuthForgotPasswordResetData, PostAuthForgotPasswordResetResponses, PostAuthForgotPasswordResponses, PostAuthForgotPasswordVerifyData, PostAuthForgotPasswordVerifyResponses, PostAuthGoogleData, PostAuthGoogleLinkData, PostAuthGoogleLinkResponses, PostAuthGoogleResponses, PostAuthLoginData, PostAuthLoginResponses, PostAuthLogoutData, PostAuthLogoutResponses, PostAuthPasswordRecoveryData, PostAuthPasswordRecoveryErrors, PostAuthPhoneVerificationRequestData, PostAuthPhoneVerificationRequestResponses, PostAuthPhoneVerificationVerifyData, PostAuthPhoneVerificationVerifyResponses, PostAuthRefreshData, PostAuthRefreshResponses, PostDocumentVaultByIdRemindersMarkSentData, PostDocumentVaultByIdRemindersMarkSentResponses, PostDocumentVaultByIdRenewData, PostDocumentVaultByIdRenewResponses, PostDocumentVaultData, PostDocumentVaultRemindersDispatchData, PostDocumentVaultRemindersDispatchResponses, PostDocumentVaultResponses, PostFlightsByFlightIdFlightRuleModeChangesData, PostFlightsByFlightIdFlightRuleModeChangesResponses, PostFlightsByFlightIdLocationsData, PostFlightsByFlightIdLocationsResponses, PostFlightsByIdPhasesByPhaseData, PostFlightsByIdPhasesByPhaseResponses, PostFlightsData, PostFlightsResponses, PostJobsAirportsImportData, PostJobsAirportsImportResponses, PostJobsAiswebCatalogImportData, PostJobsAiswebCatalogImportErrors, PostJobsAiswebCatalogImportResponses, PostJobsAnacAircraftSyncData, PostJobsAnacAircraftSyncResponses, PostJobsAnacSyncData, PostJobsAnacSyncResponses, PostNotificationsAdminBroadcastsData, PostNotificationsAdminBroadcastsResponses, PostNotificationsAdminTemplatesData, PostNotificationsAdminTemplatesResponses, PostNotificationsBroadcastsData, PostNotificationsBroadcastsResponses, PostNotificationsByIdAckData, PostNotificationsByIdAckResponses, PostRouteTemplatesData, PostRouteTemplatesResponses, PostRouteTemplatesSyncData, PostRouteTemplatesSyncResponses, PostUsersByIdBreakglassTaxIdData, PostUsersByIdBreakglassTaxIdResponses, PostUsersByIdPilotIdentityData, PostUsersByIdPilotIdentityResponses, PostUsersByIdSecurityOverridesData, PostUsersByIdSecurityOverridesResponses, PostUsersData, PostUsersMeAvatarData, PostUsersMeAvatarResponses, PostUsersRecoveryPasswordData, PostUsersRecoveryPasswordResponses, PostUsersResponses, PutAircraftsByIdOwnersData, PutAircraftsByIdOwnersResponses, PutAirportsFavoritesByAirportIdData, PutAirportsFavoritesByAirportIdResponses, PutUsersMeDeviceRegistrationsData, PutUsersMeDeviceRegistrationsResponses } from './types.gen.js';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Remove incorrect flight location point
 *
 * Admin-only soft removal for one existing flight-location point. Requires a non-blank justification, records immutable audit evidence, and excludes the point from normal historical and latest-position reads.
 */
export const postAdminFlightsByFlightIdLocationsByPointIdRemovalRequests = <ThrowOnError extends boolean = false>(options: Options<PostAdminFlightsByFlightIdLocationsByPointIdRemovalRequestsData, ThrowOnError>): RequestResult<PostAdminFlightsByFlightIdLocationsByPointIdRemovalRequestsResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostAdminFlightsByFlightIdLocationsByPointIdRemovalRequestsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/flights/{flight_id}/locations/{point_id}/removal-requests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Execute restricted admin SQL query
 *
 * Executes one backend-validated read-only SQL statement for support diagnostics. Access is restricted to the explicitly approved operator user and results are returned in fixed 100-row pages.
 */
export const postAdminQuery = <ThrowOnError extends boolean = false>(options: Options<PostAdminQueryData, ThrowOnError>): RequestResult<PostAdminQueryResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostAdminQueryResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/query',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get aircrafts
 *
 * Generated from backend router registrations.
 */
export const getAircrafts = <ThrowOnError extends boolean = false>(options?: Options<GetAircraftsData, ThrowOnError>): RequestResult<GetAircraftsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAircraftsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/aircrafts',
    ...options
});

/**
 * Post aircrafts
 *
 * Generated from backend router registrations.
 */
export const postAircrafts = <ThrowOnError extends boolean = false>(options?: Options<PostAircraftsData, ThrowOnError>): RequestResult<PostAircraftsResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostAircraftsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/aircrafts',
    ...options
});

/**
 * Get aircrafts by registration by tail number
 *
 * Generated from backend router registrations.
 */
export const getAircraftsByRegistrationByTailNumber = <ThrowOnError extends boolean = false>(options: Options<GetAircraftsByRegistrationByTailNumberData, ThrowOnError>): RequestResult<GetAircraftsByRegistrationByTailNumberResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetAircraftsByRegistrationByTailNumberResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/aircrafts/by-registration/{tailNumber}',
    ...options
});

/**
 * Patch aircrafts by ID
 *
 * Generated from backend router registrations.
 */
export const patchAircraftsById = <ThrowOnError extends boolean = false>(options: Options<PatchAircraftsByIdData, ThrowOnError>): RequestResult<PatchAircraftsByIdResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchAircraftsByIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/aircrafts/{id}',
    ...options
});

/**
 * Get aircrafts by ID documents
 *
 * Generated from backend router registrations.
 */
export const getAircraftsByIdDocuments = <ThrowOnError extends boolean = false>(options: Options<GetAircraftsByIdDocumentsData, ThrowOnError>): RequestResult<GetAircraftsByIdDocumentsResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetAircraftsByIdDocumentsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/aircrafts/{id}/documents',
    ...options
});

/**
 * Post aircrafts by ID documents
 *
 * Generated from backend router registrations.
 */
export const postAircraftsByIdDocuments = <ThrowOnError extends boolean = false>(options: Options<PostAircraftsByIdDocumentsData, ThrowOnError>): RequestResult<PostAircraftsByIdDocumentsResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostAircraftsByIdDocumentsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/aircrafts/{id}/documents',
    ...options
});

/**
 * Get aircrafts by ID owners
 *
 * Generated from backend router registrations.
 */
export const getAircraftsByIdOwners = <ThrowOnError extends boolean = false>(options: Options<GetAircraftsByIdOwnersData, ThrowOnError>): RequestResult<GetAircraftsByIdOwnersResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetAircraftsByIdOwnersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/aircrafts/{id}/owners',
    ...options
});

/**
 * Put aircrafts by ID owners
 *
 * Generated from backend router registrations.
 */
export const putAircraftsByIdOwners = <ThrowOnError extends boolean = false>(options: Options<PutAircraftsByIdOwnersData, ThrowOnError>): RequestResult<PutAircraftsByIdOwnersResponses, unknown, ThrowOnError> => (options.client ?? client).put<PutAircraftsByIdOwnersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/aircrafts/{id}/owners',
    ...options
});

/**
 * Post aircrafts by ID weight balance validate
 *
 * Generated from backend router registrations.
 */
export const postAircraftsByIdWeightBalanceValidate = <ThrowOnError extends boolean = false>(options: Options<PostAircraftsByIdWeightBalanceValidateData, ThrowOnError>): RequestResult<PostAircraftsByIdWeightBalanceValidateResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostAircraftsByIdWeightBalanceValidateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/aircrafts/{id}/weight-balance/validate',
    ...options
});

/**
 * Get airports
 *
 * Generated from backend router registrations.
 */
export const getAirports = <ThrowOnError extends boolean = false>(options?: Options<GetAirportsData, ThrowOnError>): RequestResult<GetAirportsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAirportsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/airports',
    ...options
});

/**
 * Create airport
 *
 * Creates a canonical airport record using the product-facing response envelope.
 */
export const postAirports = <ThrowOnError extends boolean = false>(options: Options<PostAirportsData, ThrowOnError>): RequestResult<PostAirportsResponses, PostAirportsErrors, ThrowOnError> => (options.client ?? client).post<PostAirportsResponses, PostAirportsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/airports',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get airports dataset history
 *
 * Generated from backend router registrations.
 */
export const getAirportsDatasetHistory = <ThrowOnError extends boolean = false>(options?: Options<GetAirportsDatasetHistoryData, ThrowOnError>): RequestResult<GetAirportsDatasetHistoryResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAirportsDatasetHistoryResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/airports/dataset/history',
    ...options
});

/**
 * Get airports dataset version
 *
 * Generated from backend router registrations.
 */
export const getAirportsDatasetVersion = <ThrowOnError extends boolean = false>(options?: Options<GetAirportsDatasetVersionData, ThrowOnError>): RequestResult<GetAirportsDatasetVersionResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAirportsDatasetVersionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/airports/dataset/version',
    ...options
});

/**
 * Get airports distance
 *
 * Generated from backend router registrations.
 */
export const getAirportsDistance = <ThrowOnError extends boolean = false>(options?: Options<GetAirportsDistanceData, ThrowOnError>): RequestResult<GetAirportsDistanceResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAirportsDistanceResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/airports/distance',
    ...options
});

/**
 * Get airports favorites
 *
 * Generated from backend router registrations.
 */
export const getAirportsFavorites = <ThrowOnError extends boolean = false>(options?: Options<GetAirportsFavoritesData, ThrowOnError>): RequestResult<GetAirportsFavoritesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAirportsFavoritesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/airports/favorites',
    ...options
});

/**
 * Post airports favorites
 *
 * Generated from backend router registrations.
 */
export const postAirportsFavorites = <ThrowOnError extends boolean = false>(options?: Options<PostAirportsFavoritesData, ThrowOnError>): RequestResult<PostAirportsFavoritesResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostAirportsFavoritesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/airports/favorites',
    ...options
});

/**
 * Get airports favorites sync
 *
 * Generated from backend router registrations.
 */
export const getAirportsFavoritesSync = <ThrowOnError extends boolean = false>(options?: Options<GetAirportsFavoritesSyncData, ThrowOnError>): RequestResult<GetAirportsFavoritesSyncResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAirportsFavoritesSyncResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/airports/favorites/sync',
    ...options
});

/**
 * Post airports favorites sync
 *
 * Generated from backend router registrations.
 */
export const postAirportsFavoritesSync = <ThrowOnError extends boolean = false>(options?: Options<PostAirportsFavoritesSyncData, ThrowOnError>): RequestResult<PostAirportsFavoritesSyncResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostAirportsFavoritesSyncResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/airports/favorites/sync',
    ...options
});

/**
 * Delete airports favorites by airport ID
 *
 * Generated from backend router registrations.
 */
export const deleteAirportsFavoritesByAirportId = <ThrowOnError extends boolean = false>(options: Options<DeleteAirportsFavoritesByAirportIdData, ThrowOnError>): RequestResult<DeleteAirportsFavoritesByAirportIdResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteAirportsFavoritesByAirportIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/airports/favorites/{airport_id}',
    ...options
});

/**
 * Put airports favorites by airport ID
 *
 * Generated from backend router registrations.
 */
export const putAirportsFavoritesByAirportId = <ThrowOnError extends boolean = false>(options: Options<PutAirportsFavoritesByAirportIdData, ThrowOnError>): RequestResult<PutAirportsFavoritesByAirportIdResponses, unknown, ThrowOnError> => (options.client ?? client).put<PutAirportsFavoritesByAirportIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/airports/favorites/{airport_id}',
    ...options
});

/**
 * Get airports nearby
 *
 * Generated from backend router registrations.
 */
export const getAirportsNearby = <ThrowOnError extends boolean = false>(options?: Options<GetAirportsNearbyData, ThrowOnError>): RequestResult<GetAirportsNearbyResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAirportsNearbyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/airports/nearby',
    ...options
});

/**
 * Get airports sync
 *
 * Generated from backend router registrations.
 *
 * @deprecated
 */
export const getAirportsSync = <ThrowOnError extends boolean = false>(options?: Options<GetAirportsSyncData, ThrowOnError>): RequestResult<unknown, GetAirportsSyncErrors, ThrowOnError> => (options?.client ?? client).get<unknown, GetAirportsSyncErrors, ThrowOnError>({ url: '/airports/sync', ...options });

/**
 * Post airports sync
 *
 * Generated from backend router registrations.
 *
 * @deprecated
 */
export const postAirportsSync = <ThrowOnError extends boolean = false>(options?: Options<PostAirportsSyncData, ThrowOnError>): RequestResult<unknown, PostAirportsSyncErrors, ThrowOnError> => (options?.client ?? client).post<unknown, PostAirportsSyncErrors, ThrowOnError>({ url: '/airports/sync', ...options });

/**
 * Get airports by ident
 *
 * Generated from backend router registrations.
 */
export const getAirportsByIdent = <ThrowOnError extends boolean = false>(options: Options<GetAirportsByIdentData, ThrowOnError>): RequestResult<GetAirportsByIdentResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetAirportsByIdentResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/airports/{ident}',
    ...options
});

/**
 * Get airports by ident frequencies
 *
 * Generated from backend router registrations.
 */
export const getAirportsByIdentFrequencies = <ThrowOnError extends boolean = false>(options: Options<GetAirportsByIdentFrequenciesData, ThrowOnError>): RequestResult<GetAirportsByIdentFrequenciesResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetAirportsByIdentFrequenciesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/airports/{ident}/frequencies',
    ...options
});

/**
 * Get airports by ident runways
 *
 * Generated from backend router registrations.
 */
export const getAirportsByIdentRunways = <ThrowOnError extends boolean = false>(options: Options<GetAirportsByIdentRunwaysData, ThrowOnError>): RequestResult<GetAirportsByIdentRunwaysResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetAirportsByIdentRunwaysResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/airports/{ident}/runways',
    ...options
});

/**
 * Get airport METAR weather
 *
 * Returns Falcon Weather V2 METAR data using the canonical envelope.
 */
export const getAirportsByIdentWeatherMetar = <ThrowOnError extends boolean = false>(options: Options<GetAirportsByIdentWeatherMetarData, ThrowOnError>): RequestResult<GetAirportsByIdentWeatherMetarResponses, GetAirportsByIdentWeatherMetarErrors, ThrowOnError> => (options.client ?? client).get<GetAirportsByIdentWeatherMetarResponses, GetAirportsByIdentWeatherMetarErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/airports/{ident}/weather/metar',
    ...options
});

/**
 * Get airport TAF weather
 *
 * Returns Falcon Weather V2 TAF data using the canonical envelope.
 */
export const getAirportsByIdentWeatherTaf = <ThrowOnError extends boolean = false>(options: Options<GetAirportsByIdentWeatherTafData, ThrowOnError>): RequestResult<GetAirportsByIdentWeatherTafResponses, GetAirportsByIdentWeatherTafErrors, ThrowOnError> => (options.client ?? client).get<GetAirportsByIdentWeatherTafResponses, GetAirportsByIdentWeatherTafErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/airports/{ident}/weather/taf',
    ...options
});

/**
 * Update airport
 *
 * Partially updates a canonical airport record by stable airport UUID using the product-facing response envelope.
 */
export const patchAirportsById = <ThrowOnError extends boolean = false>(options: Options<PatchAirportsByIdData, ThrowOnError>): RequestResult<PatchAirportsByIdResponses, PatchAirportsByIdErrors, ThrowOnError> => (options.client ?? client).patch<PatchAirportsByIdResponses, PatchAirportsByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/airports/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post auth bootstrap first admin
 *
 * Generated from backend router registrations.
 */
export const postAuthBootstrapFirstAdmin = <ThrowOnError extends boolean = false>(options?: Options<PostAuthBootstrapFirstAdminData, ThrowOnError>): RequestResult<PostAuthBootstrapFirstAdminResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostAuthBootstrapFirstAdminResponses, unknown, ThrowOnError>({ url: '/auth/bootstrap/first-admin', ...options });

/**
 * Post auth change password
 *
 * Generated from backend router registrations.
 */
export const postAuthChangePassword = <ThrowOnError extends boolean = false>(options?: Options<PostAuthChangePasswordData, ThrowOnError>): RequestResult<PostAuthChangePasswordResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostAuthChangePasswordResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/change-password',
    ...options
});

/**
 * Post auth email verification resend
 *
 * Generated from backend router registrations.
 */
export const postAuthEmailVerificationResend = <ThrowOnError extends boolean = false>(options?: Options<PostAuthEmailVerificationResendData, ThrowOnError>): RequestResult<PostAuthEmailVerificationResendResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostAuthEmailVerificationResendResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/email-verification/resend',
    ...options
});

/**
 * Post auth email verification verify
 *
 * Generated from backend router registrations.
 */
export const postAuthEmailVerificationVerify = <ThrowOnError extends boolean = false>(options?: Options<PostAuthEmailVerificationVerifyData, ThrowOnError>): RequestResult<PostAuthEmailVerificationVerifyResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostAuthEmailVerificationVerifyResponses, unknown, ThrowOnError>({ url: '/auth/email-verification/verify', ...options });

/**
 * Post auth forgot password
 *
 * Generated from backend router registrations.
 */
export const postAuthForgotPassword = <ThrowOnError extends boolean = false>(options?: Options<PostAuthForgotPasswordData, ThrowOnError>): RequestResult<PostAuthForgotPasswordResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostAuthForgotPasswordResponses, unknown, ThrowOnError>({ url: '/auth/forgot-password', ...options });

/**
 * Post auth forgot password reset
 *
 * Generated from backend router registrations.
 */
export const postAuthForgotPasswordReset = <ThrowOnError extends boolean = false>(options?: Options<PostAuthForgotPasswordResetData, ThrowOnError>): RequestResult<PostAuthForgotPasswordResetResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostAuthForgotPasswordResetResponses, unknown, ThrowOnError>({ url: '/auth/forgot-password/reset', ...options });

/**
 * Post auth forgot password verify
 *
 * Generated from backend router registrations.
 */
export const postAuthForgotPasswordVerify = <ThrowOnError extends boolean = false>(options?: Options<PostAuthForgotPasswordVerifyData, ThrowOnError>): RequestResult<PostAuthForgotPasswordVerifyResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostAuthForgotPasswordVerifyResponses, unknown, ThrowOnError>({ url: '/auth/forgot-password/verify', ...options });

/**
 * Post auth google
 *
 * Generated from backend router registrations.
 */
export const postAuthGoogle = <ThrowOnError extends boolean = false>(options?: Options<PostAuthGoogleData, ThrowOnError>): RequestResult<PostAuthGoogleResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostAuthGoogleResponses, unknown, ThrowOnError>({ url: '/auth/google', ...options });

/**
 * Post auth google link
 *
 * Generated from backend router registrations.
 */
export const postAuthGoogleLink = <ThrowOnError extends boolean = false>(options?: Options<PostAuthGoogleLinkData, ThrowOnError>): RequestResult<PostAuthGoogleLinkResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostAuthGoogleLinkResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/google/link',
    ...options
});

/**
 * Post auth login
 *
 * Generated from backend router registrations.
 */
export const postAuthLogin = <ThrowOnError extends boolean = false>(options?: Options<PostAuthLoginData, ThrowOnError>): RequestResult<PostAuthLoginResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostAuthLoginResponses, unknown, ThrowOnError>({ url: '/auth/login', ...options });

/**
 * Post auth logout
 *
 * Generated from backend router registrations.
 */
export const postAuthLogout = <ThrowOnError extends boolean = false>(options?: Options<PostAuthLogoutData, ThrowOnError>): RequestResult<PostAuthLogoutResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostAuthLogoutResponses, unknown, ThrowOnError>({ url: '/auth/logout', ...options });

/**
 * Post auth password recovery
 *
 * Generated from backend router registrations.
 *
 * @deprecated
 */
export const postAuthPasswordRecovery = <ThrowOnError extends boolean = false>(options?: Options<PostAuthPasswordRecoveryData, ThrowOnError>): RequestResult<unknown, PostAuthPasswordRecoveryErrors, ThrowOnError> => (options?.client ?? client).post<unknown, PostAuthPasswordRecoveryErrors, ThrowOnError>({ url: '/auth/password-recovery', ...options });

/**
 * Post auth phone verification request
 *
 * Generated from backend router registrations.
 */
export const postAuthPhoneVerificationRequest = <ThrowOnError extends boolean = false>(options?: Options<PostAuthPhoneVerificationRequestData, ThrowOnError>): RequestResult<PostAuthPhoneVerificationRequestResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostAuthPhoneVerificationRequestResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/phone-verification/request',
    ...options
});

/**
 * Post auth phone verification verify
 *
 * Generated from backend router registrations.
 */
export const postAuthPhoneVerificationVerify = <ThrowOnError extends boolean = false>(options?: Options<PostAuthPhoneVerificationVerifyData, ThrowOnError>): RequestResult<PostAuthPhoneVerificationVerifyResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostAuthPhoneVerificationVerifyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/phone-verification/verify',
    ...options
});

/**
 * Post auth refresh
 *
 * Generated from backend router registrations.
 */
export const postAuthRefresh = <ThrowOnError extends boolean = false>(options?: Options<PostAuthRefreshData, ThrowOnError>): RequestResult<PostAuthRefreshResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostAuthRefreshResponses, unknown, ThrowOnError>({ url: '/auth/refresh', ...options });

/**
 * Get document vault
 *
 * Generated from backend router registrations.
 */
export const getDocumentVault = <ThrowOnError extends boolean = false>(options?: Options<GetDocumentVaultData, ThrowOnError>): RequestResult<GetDocumentVaultResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetDocumentVaultResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/document-vault',
    ...options
});

/**
 * Post document vault
 *
 * Generated from backend router registrations.
 */
export const postDocumentVault = <ThrowOnError extends boolean = false>(options?: Options<PostDocumentVaultData, ThrowOnError>): RequestResult<PostDocumentVaultResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostDocumentVaultResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/document-vault',
    ...options
});

/**
 * Post document vault reminders dispatch
 *
 * Generated from backend router registrations.
 */
export const postDocumentVaultRemindersDispatch = <ThrowOnError extends boolean = false>(options?: Options<PostDocumentVaultRemindersDispatchData, ThrowOnError>): RequestResult<PostDocumentVaultRemindersDispatchResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostDocumentVaultRemindersDispatchResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/document-vault/reminders/dispatch',
    ...options
});

/**
 * Get document vault reminders due
 *
 * Generated from backend router registrations.
 */
export const getDocumentVaultRemindersDue = <ThrowOnError extends boolean = false>(options?: Options<GetDocumentVaultRemindersDueData, ThrowOnError>): RequestResult<GetDocumentVaultRemindersDueResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetDocumentVaultRemindersDueResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/document-vault/reminders/due',
    ...options
});

/**
 * Get document vault by ID
 *
 * Generated from backend router registrations.
 */
export const getDocumentVaultById = <ThrowOnError extends boolean = false>(options: Options<GetDocumentVaultByIdData, ThrowOnError>): RequestResult<GetDocumentVaultByIdResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetDocumentVaultByIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/document-vault/{id}',
    ...options
});

/**
 * Get document vault by ID download
 *
 * Generated from backend router registrations.
 */
export const getDocumentVaultByIdDownload = <ThrowOnError extends boolean = false>(options: Options<GetDocumentVaultByIdDownloadData, ThrowOnError>): RequestResult<GetDocumentVaultByIdDownloadResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetDocumentVaultByIdDownloadResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/document-vault/{id}/download',
    ...options
});

/**
 * Post document vault by ID reminders mark sent
 *
 * Generated from backend router registrations.
 */
export const postDocumentVaultByIdRemindersMarkSent = <ThrowOnError extends boolean = false>(options: Options<PostDocumentVaultByIdRemindersMarkSentData, ThrowOnError>): RequestResult<PostDocumentVaultByIdRemindersMarkSentResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostDocumentVaultByIdRemindersMarkSentResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/document-vault/{id}/reminders/mark-sent',
    ...options
});

/**
 * Post document vault by ID renew
 *
 * Generated from backend router registrations.
 */
export const postDocumentVaultByIdRenew = <ThrowOnError extends boolean = false>(options: Options<PostDocumentVaultByIdRenewData, ThrowOnError>): RequestResult<PostDocumentVaultByIdRenewResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostDocumentVaultByIdRenewResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/document-vault/{id}/renew',
    ...options
});

/**
 * List flights
 *
 * Lists authorized flights in bounded pages ordered by scheduled_start newest-to-oldest with created_at as the tie-breaker. Clients must follow has_next_page and next_offset to intentionally drain all matching flights.
 */
export const getFlights = <ThrowOnError extends boolean = false>(options?: Options<GetFlightsData, ThrowOnError>): RequestResult<GetFlightsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetFlightsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/flights',
    ...options
});

/**
 * Create flight
 *
 * Creates a scheduled flight. Same-airport local flights are allowed only when the request provides a positive manual distance_nm.
 */
export const postFlights = <ThrowOnError extends boolean = false>(options?: Options<PostFlightsData, ThrowOnError>): RequestResult<PostFlightsResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostFlightsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/flights',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get flights metrics
 *
 * Generated from backend router registrations.
 */
export const getFlightsMetrics = <ThrowOnError extends boolean = false>(options?: Options<GetFlightsMetricsData, ThrowOnError>): RequestResult<GetFlightsMetricsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetFlightsMetricsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/flights/metrics',
    ...options
});

/**
 * Record flight rule mode change
 *
 * Records one pilot-entered VFR/IFR mode change during an active flight using client_mode_change_id as the idempotency key.
 */
export const postFlightsByFlightIdFlightRuleModeChanges = <ThrowOnError extends boolean = false>(options: Options<PostFlightsByFlightIdFlightRuleModeChangesData, ThrowOnError>): RequestResult<PostFlightsByFlightIdFlightRuleModeChangesResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostFlightsByFlightIdFlightRuleModeChangesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/flights/{flight_id}/flight-rule-mode-changes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List flight locations
 *
 * Returns one paginated operational flight-location history page ordered by backend receipt cursor. Administratively removed points are excluded from this normal historical read.
 */
export const getFlightsByFlightIdLocations = <ThrowOnError extends boolean = false>(options: Options<GetFlightsByFlightIdLocationsData, ThrowOnError>): RequestResult<GetFlightsByFlightIdLocationsResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetFlightsByFlightIdLocationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/flights/{flight_id}/locations',
    ...options
});

/**
 * Ingest flight locations
 *
 * Ingests at most 25 mobile flight-location points with capture-time phase, idempotency key, capture reason, quality metadata, and acknowledgement counts.
 */
export const postFlightsByFlightIdLocations = <ThrowOnError extends boolean = false>(options: Options<PostFlightsByFlightIdLocationsData, ThrowOnError>): RequestResult<PostFlightsByFlightIdLocationsResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostFlightsByFlightIdLocationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/flights/{flight_id}/locations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get latest flight location
 *
 * Generated from backend router registrations.
 */
export const getFlightsByFlightIdLocationsLatest = <ThrowOnError extends boolean = false>(options: Options<GetFlightsByFlightIdLocationsLatestData, ThrowOnError>): RequestResult<GetFlightsByFlightIdLocationsLatestResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetFlightsByFlightIdLocationsLatestResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/flights/{flight_id}/locations/latest',
    ...options
});

/**
 * Get flight time classification
 *
 * Returns integer-second VFR/IFR totals and day/night calculation state without changing the canonical completed-flight duration fields.
 */
export const getFlightsByFlightIdTimeClassification = <ThrowOnError extends boolean = false>(options: Options<GetFlightsByFlightIdTimeClassificationData, ThrowOnError>): RequestResult<GetFlightsByFlightIdTimeClassificationResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetFlightsByFlightIdTimeClassificationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/flights/{flight_id}/time-classification',
    ...options
});

/**
 * Delete flights by ID
 *
 * Generated from backend router registrations.
 */
export const deleteFlightsById = <ThrowOnError extends boolean = false>(options: Options<DeleteFlightsByIdData, ThrowOnError>): RequestResult<DeleteFlightsByIdResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteFlightsByIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/flights/{id}',
    ...options
});

/**
 * Get flight
 *
 * Generated from backend router registrations.
 */
export const getFlightsById = <ThrowOnError extends boolean = false>(options: Options<GetFlightsByIdData, ThrowOnError>): RequestResult<GetFlightsByIdResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetFlightsByIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/flights/{id}',
    ...options
});

/**
 * Update flight
 *
 * Partially updates a scheduled flight. When fuel_liters is provided, fuel_density_kg_per_l may provide the effective UI-selected density for conversion.
 */
export const patchFlightsById = <ThrowOnError extends boolean = false>(options: Options<PatchFlightsByIdData, ThrowOnError>): RequestResult<PatchFlightsByIdResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchFlightsByIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/flights/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel flight
 *
 * Generated from backend router registrations.
 */
export const patchFlightsByIdCancel = <ThrowOnError extends boolean = false>(options: Options<PatchFlightsByIdCancelData, ThrowOnError>): RequestResult<PatchFlightsByIdCancelResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchFlightsByIdCancelResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/flights/{id}/cancel',
    ...options
});

/**
 * Log flight phase
 *
 * Generated from backend router registrations.
 */
export const postFlightsByIdPhasesByPhase = <ThrowOnError extends boolean = false>(options: Options<PostFlightsByIdPhasesByPhaseData, ThrowOnError>): RequestResult<PostFlightsByIdPhasesByPhaseResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostFlightsByIdPhasesByPhaseResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/flights/{id}/phases/{phase}',
    ...options
});

/**
 * Post jobs airports import
 *
 * Generated from backend router registrations.
 */
export const postJobsAirportsImport = <ThrowOnError extends boolean = false>(options?: Options<PostJobsAirportsImportData, ThrowOnError>): RequestResult<PostJobsAirportsImportResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostJobsAirportsImportResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/jobs/airports/import',
    ...options
});

/**
 * Queue AISWEB catalog import
 *
 * Queues a controlled AISWEB ROTAER catalog import for explicit Brazilian ICAO codes. The backend fetches one sanitized ROTAER detail request per ICAO and then runs deterministic catalog reconciliation.
 */
export const postJobsAiswebCatalogImport = <ThrowOnError extends boolean = false>(options: Options<PostJobsAiswebCatalogImportData, ThrowOnError>): RequestResult<PostJobsAiswebCatalogImportResponses, PostJobsAiswebCatalogImportErrors, ThrowOnError> => (options.client ?? client).post<PostJobsAiswebCatalogImportResponses, PostJobsAiswebCatalogImportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/jobs/aisweb/catalog/import',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post jobs anac aircraft sync
 *
 * Generated from backend router registrations.
 */
export const postJobsAnacAircraftSync = <ThrowOnError extends boolean = false>(options?: Options<PostJobsAnacAircraftSyncData, ThrowOnError>): RequestResult<PostJobsAnacAircraftSyncResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostJobsAnacAircraftSyncResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/jobs/anac/aircraft/sync',
    ...options
});

/**
 * Post jobs anac sync
 *
 * Generated from backend router registrations.
 */
export const postJobsAnacSync = <ThrowOnError extends boolean = false>(options?: Options<PostJobsAnacSyncData, ThrowOnError>): RequestResult<PostJobsAnacSyncResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostJobsAnacSyncResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/jobs/anac/sync',
    ...options
});

/**
 * Get jobs status
 *
 * Generated from backend router registrations.
 */
export const getJobsStatus = <ThrowOnError extends boolean = false>(options?: Options<GetJobsStatusData, ThrowOnError>): RequestResult<GetJobsStatusResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetJobsStatusResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/jobs/status',
    ...options
});

/**
 * Get navaids
 *
 * Generated from backend router registrations.
 */
export const getNavaids = <ThrowOnError extends boolean = false>(options?: Options<GetNavaidsData, ThrowOnError>): RequestResult<GetNavaidsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetNavaidsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/navaids',
    ...options
});

/**
 * Get navaids by ident
 *
 * Generated from backend router registrations.
 */
export const getNavaidsByIdent = <ThrowOnError extends boolean = false>(options: Options<GetNavaidsByIdentData, ThrowOnError>): RequestResult<GetNavaidsByIdentResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetNavaidsByIdentResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/navaids/{ident}',
    ...options
});

/**
 * Get notifications
 *
 * Generated from backend router registrations.
 */
export const getNotifications = <ThrowOnError extends boolean = false>(options?: Options<GetNotificationsData, ThrowOnError>): RequestResult<GetNotificationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetNotificationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notifications',
    ...options
});

/**
 * Get notifications admin acknowledgements
 *
 * Generated from backend router registrations.
 */
export const getNotificationsAdminAcknowledgements = <ThrowOnError extends boolean = false>(options?: Options<GetNotificationsAdminAcknowledgementsData, ThrowOnError>): RequestResult<GetNotificationsAdminAcknowledgementsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetNotificationsAdminAcknowledgementsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notifications/admin/acknowledgements',
    ...options
});

/**
 * Get notifications admin broadcasts
 *
 * Generated from backend router registrations.
 */
export const getNotificationsAdminBroadcasts = <ThrowOnError extends boolean = false>(options?: Options<GetNotificationsAdminBroadcastsData, ThrowOnError>): RequestResult<GetNotificationsAdminBroadcastsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetNotificationsAdminBroadcastsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notifications/admin/broadcasts',
    ...options
});

/**
 * Post notifications admin broadcasts
 *
 * Generated from backend router registrations.
 */
export const postNotificationsAdminBroadcasts = <ThrowOnError extends boolean = false>(options: Options<PostNotificationsAdminBroadcastsData, ThrowOnError>): RequestResult<PostNotificationsAdminBroadcastsResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostNotificationsAdminBroadcastsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notifications/admin/broadcasts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get notifications admin deliveries
 *
 * Generated from backend router registrations.
 */
export const getNotificationsAdminDeliveries = <ThrowOnError extends boolean = false>(options?: Options<GetNotificationsAdminDeliveriesData, ThrowOnError>): RequestResult<GetNotificationsAdminDeliveriesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetNotificationsAdminDeliveriesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notifications/admin/deliveries',
    ...options
});

/**
 * Get notifications admin escalations
 *
 * Generated from backend router registrations.
 */
export const getNotificationsAdminEscalations = <ThrowOnError extends boolean = false>(options?: Options<GetNotificationsAdminEscalationsData, ThrowOnError>): RequestResult<GetNotificationsAdminEscalationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetNotificationsAdminEscalationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notifications/admin/escalations',
    ...options
});

/**
 * Get notifications admin events
 *
 * Generated from backend router registrations.
 */
export const getNotificationsAdminEvents = <ThrowOnError extends boolean = false>(options?: Options<GetNotificationsAdminEventsData, ThrowOnError>): RequestResult<GetNotificationsAdminEventsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetNotificationsAdminEventsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notifications/admin/events',
    ...options
});

/**
 * Get notifications admin notifications
 *
 * Generated from backend router registrations.
 */
export const getNotificationsAdminNotifications = <ThrowOnError extends boolean = false>(options?: Options<GetNotificationsAdminNotificationsData, ThrowOnError>): RequestResult<GetNotificationsAdminNotificationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetNotificationsAdminNotificationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notifications/admin/notifications',
    ...options
});

/**
 * Get notifications admin templates
 *
 * Generated from backend router registrations.
 */
export const getNotificationsAdminTemplates = <ThrowOnError extends boolean = false>(options?: Options<GetNotificationsAdminTemplatesData, ThrowOnError>): RequestResult<GetNotificationsAdminTemplatesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetNotificationsAdminTemplatesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notifications/admin/templates',
    ...options
});

/**
 * Post notifications admin templates
 *
 * Generated from backend router registrations.
 */
export const postNotificationsAdminTemplates = <ThrowOnError extends boolean = false>(options: Options<PostNotificationsAdminTemplatesData, ThrowOnError>): RequestResult<PostNotificationsAdminTemplatesResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostNotificationsAdminTemplatesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notifications/admin/templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get notifications admin templates by code
 *
 * Generated from backend router registrations.
 */
export const getNotificationsAdminTemplatesByCode = <ThrowOnError extends boolean = false>(options: Options<GetNotificationsAdminTemplatesByCodeData, ThrowOnError>): RequestResult<GetNotificationsAdminTemplatesByCodeResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetNotificationsAdminTemplatesByCodeResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notifications/admin/templates/{code}',
    ...options
});

/**
 * Post notifications broadcasts
 *
 * Generated from backend router registrations.
 */
export const postNotificationsBroadcasts = <ThrowOnError extends boolean = false>(options?: Options<PostNotificationsBroadcastsData, ThrowOnError>): RequestResult<PostNotificationsBroadcastsResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostNotificationsBroadcastsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notifications/broadcasts',
    ...options
});

/**
 * Get notifications sync
 *
 * Generated from backend router registrations.
 */
export const getNotificationsSync = <ThrowOnError extends boolean = false>(options?: Options<GetNotificationsSyncData, ThrowOnError>): RequestResult<GetNotificationsSyncResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetNotificationsSyncResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notifications/sync',
    ...options
});

/**
 * Get notifications by ID
 *
 * Generated from backend router registrations.
 */
export const getNotificationsById = <ThrowOnError extends boolean = false>(options: Options<GetNotificationsByIdData, ThrowOnError>): RequestResult<GetNotificationsByIdResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetNotificationsByIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notifications/{id}',
    ...options
});

/**
 * Post notifications by ID ack
 *
 * Generated from backend router registrations.
 */
export const postNotificationsByIdAck = <ThrowOnError extends boolean = false>(options: Options<PostNotificationsByIdAckData, ThrowOnError>): RequestResult<PostNotificationsByIdAckResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostNotificationsByIdAckResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notifications/{id}/ack',
    ...options
});

/**
 * Patch notifications by ID read
 *
 * Generated from backend router registrations.
 */
export const patchNotificationsByIdRead = <ThrowOnError extends boolean = false>(options: Options<PatchNotificationsByIdReadData, ThrowOnError>): RequestResult<PatchNotificationsByIdReadResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchNotificationsByIdReadResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notifications/{id}/read',
    ...options
});

/**
 * Get pilots by pilot ID schedules full
 *
 * Generated from backend router registrations.
 */
export const getPilotsByPilotIdSchedulesFull = <ThrowOnError extends boolean = false>(options: Options<GetPilotsByPilotIdSchedulesFullData, ThrowOnError>): RequestResult<GetPilotsByPilotIdSchedulesFullResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetPilotsByPilotIdSchedulesFullResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/pilots/{pilot_id}/schedules/full',
    ...options
});

/**
 * Get pilots by pilot ID schedules metrics
 *
 * Generated from backend router registrations.
 */
export const getPilotsByPilotIdSchedulesMetrics = <ThrowOnError extends boolean = false>(options: Options<GetPilotsByPilotIdSchedulesMetricsData, ThrowOnError>): RequestResult<GetPilotsByPilotIdSchedulesMetricsResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetPilotsByPilotIdSchedulesMetricsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/pilots/{pilot_id}/schedules/metrics',
    ...options
});

/**
 * Get pilots by pilot ID schedules monthly
 *
 * Generated from backend router registrations.
 */
export const getPilotsByPilotIdSchedulesMonthly = <ThrowOnError extends boolean = false>(options: Options<GetPilotsByPilotIdSchedulesMonthlyData, ThrowOnError>): RequestResult<GetPilotsByPilotIdSchedulesMonthlyResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetPilotsByPilotIdSchedulesMonthlyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/pilots/{pilot_id}/schedules/monthly',
    ...options
});

/**
 * Get pilots by pilot ID schedules pending
 *
 * Returns actionable delayed, scheduled, and in-progress flights for the authenticated pilot or selected pilot.
 */
export const getPilotsByPilotIdSchedulesPending = <ThrowOnError extends boolean = false>(options: Options<GetPilotsByPilotIdSchedulesPendingData, ThrowOnError>): RequestResult<GetPilotsByPilotIdSchedulesPendingResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetPilotsByPilotIdSchedulesPendingResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/pilots/{pilot_id}/schedules/pending',
    ...options
});

/**
 * Get pilots by pilot ID schedules upcoming
 *
 * Generated from backend router registrations.
 */
export const getPilotsByPilotIdSchedulesUpcoming = <ThrowOnError extends boolean = false>(options: Options<GetPilotsByPilotIdSchedulesUpcomingData, ThrowOnError>): RequestResult<GetPilotsByPilotIdSchedulesUpcomingResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetPilotsByPilotIdSchedulesUpcomingResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/pilots/{pilot_id}/schedules/upcoming',
    ...options
});

/**
 * Get pilots by pilot ID schedules weekly
 *
 * Generated from backend router registrations.
 */
export const getPilotsByPilotIdSchedulesWeekly = <ThrowOnError extends boolean = false>(options: Options<GetPilotsByPilotIdSchedulesWeeklyData, ThrowOnError>): RequestResult<GetPilotsByPilotIdSchedulesWeeklyResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetPilotsByPilotIdSchedulesWeeklyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/pilots/{pilot_id}/schedules/weekly',
    ...options
});

/**
 * Get qualifications report
 *
 * Generated from backend router registrations.
 */
export const getQualificationsReport = <ThrowOnError extends boolean = false>(options?: Options<GetQualificationsReportData, ThrowOnError>): RequestResult<GetQualificationsReportResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetQualificationsReportResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/qualifications/report',
    ...options
});

/**
 * Get reports flight operations
 *
 * Generated from backend router registrations.
 */
export const getReportsFlightOperations = <ThrowOnError extends boolean = false>(options?: Options<GetReportsFlightOperationsData, ThrowOnError>): RequestResult<GetReportsFlightOperationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetReportsFlightOperationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/reports/flight-operations',
    ...options
});

/**
 * Get route templates
 *
 * Generated from backend router registrations.
 */
export const getRouteTemplates = <ThrowOnError extends boolean = false>(options?: Options<GetRouteTemplatesData, ThrowOnError>): RequestResult<GetRouteTemplatesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetRouteTemplatesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/route-templates',
    ...options
});

/**
 * Post route templates
 *
 * Generated from backend router registrations.
 */
export const postRouteTemplates = <ThrowOnError extends boolean = false>(options?: Options<PostRouteTemplatesData, ThrowOnError>): RequestResult<PostRouteTemplatesResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostRouteTemplatesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/route-templates',
    ...options
});

/**
 * Get route templates sync
 *
 * Generated from backend router registrations.
 */
export const getRouteTemplatesSync = <ThrowOnError extends boolean = false>(options?: Options<GetRouteTemplatesSyncData, ThrowOnError>): RequestResult<GetRouteTemplatesSyncResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetRouteTemplatesSyncResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/route-templates/sync',
    ...options
});

/**
 * Post route templates sync
 *
 * Generated from backend router registrations.
 */
export const postRouteTemplatesSync = <ThrowOnError extends boolean = false>(options?: Options<PostRouteTemplatesSyncData, ThrowOnError>): RequestResult<PostRouteTemplatesSyncResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostRouteTemplatesSyncResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/route-templates/sync',
    ...options
});

/**
 * Delete route templates by ID
 *
 * Generated from backend router registrations.
 */
export const deleteRouteTemplatesById = <ThrowOnError extends boolean = false>(options: Options<DeleteRouteTemplatesByIdData, ThrowOnError>): RequestResult<DeleteRouteTemplatesByIdResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteRouteTemplatesByIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/route-templates/{id}',
    ...options
});

/**
 * Get route templates by ID
 *
 * Generated from backend router registrations.
 */
export const getRouteTemplatesById = <ThrowOnError extends boolean = false>(options: Options<GetRouteTemplatesByIdData, ThrowOnError>): RequestResult<GetRouteTemplatesByIdResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetRouteTemplatesByIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/route-templates/{id}',
    ...options
});

/**
 * Patch route templates by ID
 *
 * Generated from backend router registrations.
 */
export const patchRouteTemplatesById = <ThrowOnError extends boolean = false>(options: Options<PatchRouteTemplatesByIdData, ThrowOnError>): RequestResult<PatchRouteTemplatesByIdResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchRouteTemplatesByIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/route-templates/{id}',
    ...options
});

/**
 * Get route templates by ID navigation
 *
 * Generated from backend router registrations.
 */
export const getRouteTemplatesByIdNavigation = <ThrowOnError extends boolean = false>(options: Options<GetRouteTemplatesByIdNavigationData, ThrowOnError>): RequestResult<GetRouteTemplatesByIdNavigationResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetRouteTemplatesByIdNavigationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/route-templates/{id}/navigation',
    ...options
});

/**
 * Get schedules full
 *
 * Generated from backend router registrations.
 */
export const getSchedulesFull = <ThrowOnError extends boolean = false>(options?: Options<GetSchedulesFullData, ThrowOnError>): RequestResult<GetSchedulesFullResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetSchedulesFullResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/schedules/full',
    ...options
});

/**
 * Get schedules metrics
 *
 * Generated from backend router registrations.
 */
export const getSchedulesMetrics = <ThrowOnError extends boolean = false>(options?: Options<GetSchedulesMetricsData, ThrowOnError>): RequestResult<GetSchedulesMetricsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetSchedulesMetricsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/schedules/metrics',
    ...options
});

/**
 * Get schedules monthly
 *
 * Generated from backend router registrations.
 */
export const getSchedulesMonthly = <ThrowOnError extends boolean = false>(options?: Options<GetSchedulesMonthlyData, ThrowOnError>): RequestResult<GetSchedulesMonthlyResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetSchedulesMonthlyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/schedules/monthly',
    ...options
});

/**
 * Get schedules pending
 *
 * Returns actionable delayed, scheduled, and in-progress flights for the authenticated pilot or selected pilot.
 */
export const getSchedulesPending = <ThrowOnError extends boolean = false>(options?: Options<GetSchedulesPendingData, ThrowOnError>): RequestResult<GetSchedulesPendingResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetSchedulesPendingResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/schedules/pending',
    ...options
});

/**
 * Get schedules upcoming
 *
 * Generated from backend router registrations.
 */
export const getSchedulesUpcoming = <ThrowOnError extends boolean = false>(options?: Options<GetSchedulesUpcomingData, ThrowOnError>): RequestResult<GetSchedulesUpcomingResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetSchedulesUpcomingResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/schedules/upcoming',
    ...options
});

/**
 * Get schedules weekly
 *
 * Generated from backend router registrations.
 */
export const getSchedulesWeekly = <ThrowOnError extends boolean = false>(options?: Options<GetSchedulesWeeklyData, ThrowOnError>): RequestResult<GetSchedulesWeeklyResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetSchedulesWeeklyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/schedules/weekly',
    ...options
});

/**
 * List users
 *
 * Returns users for backoffice administration. Pilot ANAC credentials are exposed only through pilot_detail.qualification and the safe medical_certificate_summary.
 */
export const getUsers = <ThrowOnError extends boolean = false>(options?: Options<GetUsersData, ThrowOnError>): RequestResult<GetUsersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetUsersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users',
    ...options
});

/**
 * Create user
 *
 * Generated from backend router registrations.
 */
export const postUsers = <ThrowOnError extends boolean = false>(options?: Options<PostUsersData, ThrowOnError>): RequestResult<PostUsersResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostUsersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users',
    ...options
});

/**
 * Get authenticated user profile
 *
 * Returns the authenticated user profile. Pilot ANAC credentials are exposed only through pilot_detail.qualification and the safe medical_certificate_summary.
 */
export const getUsersMe = <ThrowOnError extends boolean = false>(options?: Options<GetUsersMeData, ThrowOnError>): RequestResult<GetUsersMeResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetUsersMeResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/me',
    ...options
});

/**
 * Delete users me avatar
 *
 * Generated from backend router registrations.
 */
export const deleteUsersMeAvatar = <ThrowOnError extends boolean = false>(options?: Options<DeleteUsersMeAvatarData, ThrowOnError>): RequestResult<DeleteUsersMeAvatarResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<DeleteUsersMeAvatarResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/me/avatar',
    ...options
});

/**
 * Post users me avatar
 *
 * Generated from backend router registrations.
 */
export const postUsersMeAvatar = <ThrowOnError extends boolean = false>(options?: Options<PostUsersMeAvatarData, ThrowOnError>): RequestResult<PostUsersMeAvatarResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostUsersMeAvatarResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/me/avatar',
    ...options
});

/**
 * Delete users me device registrations
 *
 * Generated from backend router registrations.
 */
export const deleteUsersMeDeviceRegistrations = <ThrowOnError extends boolean = false>(options?: Options<DeleteUsersMeDeviceRegistrationsData, ThrowOnError>): RequestResult<DeleteUsersMeDeviceRegistrationsResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<DeleteUsersMeDeviceRegistrationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/me/device-registrations',
    ...options
});

/**
 * Put users me device registrations
 *
 * Generated from backend router registrations.
 */
export const putUsersMeDeviceRegistrations = <ThrowOnError extends boolean = false>(options?: Options<PutUsersMeDeviceRegistrationsData, ThrowOnError>): RequestResult<PutUsersMeDeviceRegistrationsResponses, unknown, ThrowOnError> => (options?.client ?? client).put<PutUsersMeDeviceRegistrationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/me/device-registrations',
    ...options
});

/**
 * Post users recovery password
 *
 * Generated from backend router registrations.
 */
export const postUsersRecoveryPassword = <ThrowOnError extends boolean = false>(options?: Options<PostUsersRecoveryPasswordData, ThrowOnError>): RequestResult<PostUsersRecoveryPasswordResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostUsersRecoveryPasswordResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/recovery/password',
    ...options
});

/**
 * Get users recovery raw
 *
 * Generated from backend router registrations.
 */
export const getUsersRecoveryRaw = <ThrowOnError extends boolean = false>(options?: Options<GetUsersRecoveryRawData, ThrowOnError>): RequestResult<GetUsersRecoveryRawResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetUsersRecoveryRawResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/recovery/raw',
    ...options
});

/**
 * Patch users by ID
 *
 * Generated from backend router registrations.
 */
export const patchUsersById = <ThrowOnError extends boolean = false>(options: Options<PatchUsersByIdData, ThrowOnError>): RequestResult<PatchUsersByIdResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchUsersByIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{id}',
    ...options
});

/**
 * Patch users by ID active
 *
 * Generated from backend router registrations.
 */
export const patchUsersByIdActive = <ThrowOnError extends boolean = false>(options: Options<PatchUsersByIdActiveData, ThrowOnError>): RequestResult<PatchUsersByIdActiveResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchUsersByIdActiveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{id}/active',
    ...options
});

/**
 * Post users by ID breakglass tax ID
 *
 * Generated from backend router registrations.
 */
export const postUsersByIdBreakglassTaxId = <ThrowOnError extends boolean = false>(options: Options<PostUsersByIdBreakglassTaxIdData, ThrowOnError>): RequestResult<PostUsersByIdBreakglassTaxIdResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostUsersByIdBreakglassTaxIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{id}/breakglass/tax-id',
    ...options
});

/**
 * Post users by ID pilot identity
 *
 * Generated from backend router registrations.
 */
export const postUsersByIdPilotIdentity = <ThrowOnError extends boolean = false>(options: Options<PostUsersByIdPilotIdentityData, ThrowOnError>): RequestResult<PostUsersByIdPilotIdentityResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostUsersByIdPilotIdentityResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{id}/pilot-identity',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Patch users by ID roles
 *
 * Generated from backend router registrations.
 */
export const patchUsersByIdRoles = <ThrowOnError extends boolean = false>(options: Options<PatchUsersByIdRolesData, ThrowOnError>): RequestResult<PatchUsersByIdRolesResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchUsersByIdRolesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{id}/roles',
    ...options
});

/**
 * Post users by ID security overrides
 *
 * Generated from backend router registrations.
 */
export const postUsersByIdSecurityOverrides = <ThrowOnError extends boolean = false>(options: Options<PostUsersByIdSecurityOverridesData, ThrowOnError>): RequestResult<PostUsersByIdSecurityOverridesResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostUsersByIdSecurityOverridesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{id}/security-overrides',
    ...options
});

/**
 * Get waypoints
 *
 * Generated from backend router registrations.
 */
export const getWaypoints = <ThrowOnError extends boolean = false>(options?: Options<GetWaypointsData, ThrowOnError>): RequestResult<GetWaypointsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetWaypointsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/waypoints',
    ...options
});

/**
 * Get waypoints nearby
 *
 * Generated from backend router registrations.
 */
export const getWaypointsNearby = <ThrowOnError extends boolean = false>(options?: Options<GetWaypointsNearbyData, ThrowOnError>): RequestResult<GetWaypointsNearbyResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetWaypointsNearbyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/waypoints/nearby',
    ...options
});

/**
 * Sync normalized aeronautical catalog
 *
 * Returns the backend-owned normalized aeronautical catalog sync payload for mobile offline storage. OurAirports remains the batch base, AISWEB enrichment is represented through source metadata when available, and raw upstream provider payloads are not exposed.
 */
export const getWaypointsSync = <ThrowOnError extends boolean = false>(options?: Options<GetWaypointsSyncData, ThrowOnError>): RequestResult<GetWaypointsSyncResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetWaypointsSyncResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/waypoints/sync',
    ...options
});

/**
 * Get normalized aeronautical catalog waypoint
 *
 * Returns one backend-owned normalized aeronautical catalog waypoint with typed airport, runway, frequency, navaid, and source metadata when available.
 */
export const getWaypointsByIdentifier = <ThrowOnError extends boolean = false>(options: Options<GetWaypointsByIdentifierData, ThrowOnError>): RequestResult<GetWaypointsByIdentifierResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetWaypointsByIdentifierResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/waypoints/{identifier}',
    ...options
});
